import { Button, ButtonSize, ButtonVariant } from '@farmasiet/frontendcore-reactcomponents';
import React, { useEffect, useState } from 'react';

import { getTranslation, keys } from '../../../../../../../Resources/Translations';
import { ProductAvailabilityNotificationSuccessModal } from '../../ProductAvailabilityNotificationSuccessModal';
import { ProductAvailabilityNotificationStatus } from './ProductAvailabilityNotificationStatus';
import { ProductAvailabilityNotificationViewProps } from './ProductAvailabilityNotificationViewProps';

export const ProductAvailabilityNotificationCardView = (props: ProductAvailabilityNotificationViewProps) => {
    const [successModalVisible, setSuccessModalVisible] = useState(false);

    useEffect(() => {
        if (props.status === ProductAvailabilityNotificationStatus.Success) {
            setSuccessModalVisible(true);
        }
    }, [props.status]);

    return (
        <div className="ProductAvailabilityNotificationCardView">
            {props.status === ProductAvailabilityNotificationStatus.Success || props.status === ProductAvailabilityNotificationStatus.LimitExceeded ? (
                <span className="ProductAvailabilityNotificationCardView__Message">
                    {getTranslation(keys['product.availabilityNotification.savedSubheading'])}
                </span>
            ) : (
                <Button
                    variant={ButtonVariant.Tertiary}
                    size={ButtonSize.XXSmall}
                    onClick={props.handleOnClick}
                    className="ProductAvailabilityNotificationCardView__Button"
                    disabled={props.isButtonDisabled && !props.isInputModalVisible}
                >
                    {getTranslation(keys['product.availabilityNotification.button'])}
                </Button>
            )}

            <ProductAvailabilityNotificationSuccessModal isVisible={successModalVisible} onClose={() => setSuccessModalVisible(false)} />
        </div>
    );
};
